import {AxiosResponse} from "axios";
import request from "./base.service";

function getInternationalVaccinationCard(): Promise<AxiosResponse<any>> {
  return request.build().get(`/api/v1/hcs/vaccinations/card?language=ENGLISH`);
}

function getInternalVaccinationCard(): Promise<AxiosResponse<any>> {
  return request.build().get('/api/v1/hcs/vaccinations/card?language=PERSIAN&lang=fa')
}

export default {
  getInternationalVaccinationCard,
  getInternalVaccinationCard
}